(function () {
    'use strict';

    angular.module('app.logTypes', [
        'app.core',
        'app.widgets',
        'ngDragDrop'
    ]);
})();
